import React from 'react';
import { formatHospitalAddress, hospitalName } from '../utils/hospitalPdf';
import { hasLetterheadAddress, isLetterheadOnPdf } from '../utils/hospitalProfile';

/** Live preview — matches PDF output (full letterhead or plain). */
export default function LetterheadPreview({ hospital, docTitle = 'Payment Receipt', docSubtitle = 'Sample document', toolbar }) {
  if (!hospital) return null;
  const name = hospitalName(hospital);
  const addr = formatHospitalAddress(hospital);
  const color = hospital.letterheadColor || '#1e40af';
  const initials = hospital.logoInitials || name.slice(0, 2).toUpperCase();
  const fullLh = isLetterheadOnPdf(hospital);

  return (
    <div className="letterhead-preview card">
      <div className="lh-preview-toolbar">
        <span className="hint">PDF header preview</span>
        {toolbar}
      </div>
      <div className="lh-preview-sheet" style={{ '--lh-color': color }}>
        {fullLh ? (
          <>
            <div className="lh-preview-top">
              <div className="lh-preview-logo" style={{ background: color }}>{initials}</div>
              <div className="lh-preview-brand">
                <strong className="lh-preview-name">{name}</strong>
                {hospital.tagline && <span className="lh-preview-tag">{hospital.tagline}</span>}
                {addr && <span className="lh-preview-addr" style={{ whiteSpace: 'pre-line' }}>{addr}</span>}
                <span className="lh-preview-contact">
                  {[hospital.phone && `Tel: ${hospital.phone}`, hospital.email, hospital.regNo && `Reg: ${hospital.regNo}`, hospital.gstin && `GSTIN: ${hospital.gstin}`].filter(Boolean).join(' · ')}
                </span>
                {hospital.website && <span className="lh-preview-web">{hospital.website}</span>}
              </div>
              <div className="lh-preview-doc">
                <strong style={{ color }}>{docTitle}</strong>
                <span>{docSubtitle}</span>
              </div>
            </div>
            <div className="lh-preview-rule" style={{ background: color }} />
            {!hasLetterheadAddress(hospital) && (
              <p className="hint" style={{ fontSize: 12, marginTop: 8 }}>Add address below for a complete letterhead.</p>
            )}
          </>
        ) : (
          <>
            <div className="lh-preview-plain">
              <div>
                <strong className="lh-preview-plain-title">{docTitle}</strong>
                <span className="hint">{docSubtitle}</span>
              </div>
              <span className="lh-preview-plain-name">{name}</span>
            </div>
            <div className="lh-preview-rule-plain" />
            <p className="hint" style={{ fontSize: 11, margin: 0 }}>Plain PDF — no letterhead (name + document title only).</p>
          </>
        )}
      </div>
    </div>
  );
}
